export type QueryJobStatus = 'queued' | 'processing' | 'success' | 'partial' | 'error';

export type QueryStatus = 'pending' | 'running' | QueryJobStatus;

export function isTerminalQueryStatus(status: string | null | undefined): boolean {
  const normalized = (status || '').toLowerCase();
  return normalized === 'success' || normalized === 'partial' || normalized === 'error';
}

export function isDisplayableResultStatus(status: string | null | undefined): boolean {
  const normalized = (status || '').toLowerCase();
  return normalized === 'success' || normalized === 'partial';
}

export function isFailedQueryStatus(status: string | null | undefined): boolean {
  return (status || '').toLowerCase() === 'error';
}

export function isPartialQueryStatus(status: string | null | undefined): boolean {
  return (status || '').toLowerCase() === 'partial';
}

export interface IQuerySubmission {
  job_id: string;
  query: string;
  status: QueryStatus;
  username: string;
  uid?: string;
  creation_time: string;
  query_s3_key?: string | null;
  result_s3_key?: string | null;
  result_url?: string | null;
  result_content_type?: string | null;
  result_content_encoding?: string | null;
  result_row_count?: number | null;
  error_message?: string | null;
  result_message?: string | null;
}

export type QueryResultRow = Record<string, unknown>;

export interface QueryJobResponseData {
  job_id: string;
  status: QueryJobStatus;
  query: string;
  error_message: string | null;
  creation_time: string;
  query_s3_key: string | null;
  result_s3_key: string | null;
  result_url: string | null;
  result_content_type: string | null;
  result_content_encoding: string | null;
  result_row_count: number | null;
  result_message: string | null;
}

export interface QueryJobResponse {
  success: boolean;
  data: QueryJobResponseData;
}
